import React, { LegacyRef } from 'react';
import { v1 as uuid } from 'uuid';
import $ from 'jquery';

import { display } from 'components/ErrorView/ErrorDialog';
import Icon from 'components/Icon';
import Input from 'components/Input';
import {
  copyItem,
  item_createNewSurvey,
  itemStatus,
  requireProviderSurveys,
  updateLocalItem,
} from 'store/providers/providerSlice';

import i18n from '../../../../i18n';
import {
  IProviderItemViewWithData,
  providerItemType,
} from '../../../../store/providers/providerTypes';
import { purple } from '../../../../utils/style/colors';
import ItemView, { IComponentProps as IComponentBaseProps } from './ItemView';
import { IComponentState as IComponentBaseState } from './ItemView';
import { IUsers } from '../../../../store/store';

interface IComponentProps extends IComponentBaseProps {
  users?: IUsers;
  mandatoryTagIds?: number[];
}

interface IComponentState extends IComponentBaseState {
  useExistingState: boolean;
}

class SurveyView extends ItemView<IComponentProps, IComponentState> {
  constructor(props: IComponentProps) {
    super(props);

    this.state = {
      ...this.state,
      useExistingState: false,
    };
  }

  previousSurveyName = React.createRef<HTMLInputElement | null>();

  componentDidMount() {
    if (this.props.item.status === itemStatus.creating) {
      this.props.dispatch(
        requireProviderSurveys({ providerId: this.props.item.data.providerId })
      );
    }
    super.componentDidMount();
  }

  componentDidUpdate() {
    super.componentDidUpdate();
    if (this.previousSurveyName.current) {
      const items = this.props.items;
      const autoCompleteItems = {};
      const surveyIdMap = {};
      Object.keys(items)
        .filter((itemKey) => {
          const item = items[itemKey];
          return (
            item.data.type === providerItemType.survey &&
            typeof item.data.id === 'number'
          );
        })
        .reduce((all, itemKey) => {
          if (
            typeof surveyIdMap[items[itemKey].data.surveyId] === 'undefined'
          ) {
            all[items[itemKey].data.id] = {
              text: items[itemKey].data.surveyName,
            };
            surveyIdMap[items[itemKey].data.surveyId] = 0;
          }
          return all;
        }, autoCompleteItems);
      ($(this.previousSurveyName.current) as any).my_autocomplete({
        data: autoCompleteItems,
        limit: 20,
        onAutocomplete: this.onChooseSurvey,
        minLength: 1,
      });
    }
    if (this.nameInput && !this.nameInput.value) {
      $(this.nameInput).val(this.props.item.data.name as string);
    }
  }

  getMenuActions(itemId: number, editable: boolean) {
    const actions = super.getMenuActions(itemId, editable);
    if (editable)
      actions.push({
        order: 10,
        callBack: this.onDuplicate,
        message: i18n.t('duplicate', { ns: 'documentManager' }),
        group: '1-actions',
      });
    return actions;
  }

  deleteItemTitle(name: string) {
    return i18n.t('deleteSurveyTitle', { ns: 'documentManager', name });
  }

  deleteItemMessage(name: string) {
    return i18n.t('deleteSurveyMessage', { ns: 'documentManager', name });
  }

  onOpenFunction(item: IProviderItemViewWithData, isNewTab: boolean) {
    return (e: any) => {
      this.props.onOpenItem(
        item,
        'responses',
        undefined,
        isNewTab || e.altKey || e.metaKey,
        this.props.mandatoryTagIds
      );
    };
  }

  getThumbnail() {
    return ['survey.svg', purple];
  }

  handelConfirmCreatingNewItem(item: IProviderItemViewWithData) {
    if (!this.state.useExistingState) {
      item.data.surveyId = undefined;
    }
    this.props.dispatch(item_createNewSurvey({ item: item.data }));
  }

  newItemPlaceHolder() {
    if (this.isIndicator())
      return i18n.t('newIndicatorPlaceHolder', { ns: 'documentManager' });
    return i18n.t('newSurveyPlaceholder', { ns: 'documentManager' });
  }

  newItemTitle() {
    if (this.isIndicator())
      return i18n.t('indicator', { ns: 'documentManager' });
    return i18n.t('newSurveyTitle', { ns: 'documentManager' });
  }

  isIndicator = () => {
    return !!this.props.item.data.tags.find(
      (it: any) => it.text === i18n.t('indicator', { ns: 'documentManager' })
    );
  };
  getCreatingView = () => {
    const surveyId = uuid();

    const formChildren = (
      <span>
        {/*<Input
          id={useExistingSurveyId}
          type="checkbox"
          onChange={(e) => this.onChangeUseExistingSurvey(e.target.checked)}
          label={message.useExistingSurvey}
        />*/}
        {!this.state.useExistingState ? null : this.props.item.data
            .providerId ? (
          <p>
            <a href="#!" className="red-text" onClick={this.onRemoveSurvey}>
              <Icon type={'x'} />
            </a>
            {this.props.items[this.props.item.data.providerId].data.name}
          </p>
        ) : (
          <Input
            placeholder={
              i18n.t('previousSurveyPlaceHolder', {
                ns: 'documentManager',
              }) as string
            }
            id={surveyId}
            type="text"
            className="autocomplete"
            required={true}
            ref={this.previousSurveyName as LegacyRef<HTMLInputElement>}
            label={
              i18n.t('previousSurveyTitle', {
                ns: 'documentManager',
              }) as string
            }
          />
        )}
      </span>
    );
    return super.getCreatingView(formChildren);
  };

  onChooseSurvey = (providerSurveyId: number) => {
    const {
      dispatch,
      items,
      item: { data },
    } = this.props;
    const surveyData = JSON.parse(JSON.stringify(data));
    surveyData.providerSurveyId = providerSurveyId;
    surveyData.surveyId = items[providerSurveyId].data.surveyId;
    surveyData.name = items[providerSurveyId].data.name;
    dispatch(updateLocalItem({ item: data }));
  };

  onRemoveSurvey = () => {
    const {
      item: { data },
      dispatch,
    } = this.props;
    const surveyData = JSON.parse(JSON.stringify(data));
    surveyData.providerSurveyId = undefined;
    dispatch(updateLocalItem({ item: surveyData }));
  };

  onDuplicate = () => {
    this.setState({ loading: true, showDropdown: false });
    const {
      item: {
        data: { id, dadId, providerId },
      },
      dispatch,
    } = this.props;
    dispatch(
      copyItem({
        srcItemId: id,
        targetItemId: dadId,
        providerId: providerId,
        forceCopy: true,
      })
    )
      .then(() => {
        this.setState({ loading: false });
      })
      .catch((err: any) => {
        display(err);
        this.setState({ loading: false });
      });
  };

  onChangeUseExistingSurvey(checked: boolean) {
    this.setState({ useExistingState: checked });
  }
}

export default SurveyView;
